export const environment = {
  production: true,
};

// export const baseUrl = 'https://pecss-test2.cloud.rnoc.gatech.edu/v1';
export const baseUrl = 'https://pecss.emory.edu/v1';
